export const MY_COLORS = 'my colors';
export const MY_STYLE = 'my style';
